




















































































import { Component } from 'vue-property-decorator';
import UnitSelector from '@/views/product/common/UnitSelector.vue';
import { AbstractProductWidget } from '@/views/product/widgets/AbstractProductWidget';
import DetailImageGallery from '@/views/product/widgets/DetailImageGallery.vue';
import DetailUnitSelector from '@/views/product/widgets/DetailUnitSelector.vue';
import { ProductImageDto, ProductUnitDto } from '@/api';
import Routes from '@/util/Routes';
import { Urls } from '@/util/Urls';
import OfferBadge from '@/views/product/common/OfferBadge.vue';
import NutritionTable from '@/views/product/nutrition/NutritionTable.vue';
import AllergensView from '@/views/product/widgets/AllergensView.vue';
import ProductDetailCartSection from '@/views/product/widgets/ProductDetailCartSection.vue';
import ProductDetailBadges from '@/views/product/widgets/ProductDetailBadges.vue';

@Component({
  components: {
    ProductDetailBadges,
    ProductDetailCartSection,
    OfferBadge,
    DetailUnitSelector,
    DetailImageGallery,
    UnitSelector,
    NutritionTable,
    AllergensView,
  },
})
export default class ProductDetail extends AbstractProductWidget {

  public get allImages(): ProductImageDto[] {
    return this.product.product.images || [];
  }

  public changeUnit(unit: ProductUnitDto): void {
    this.$router.push({
      name: Routes.ProductDetail,
      params: {
        sku: this.product.product.sku,
        unitAbbreviation: unit.abbreviation,
        urlName: Urls.toLinkFriendlyString(this.product.product.name),
      },
    });
  }

  get hasContainedAllergens(): boolean {
    return !!this.product.product.allergensContained && this.product.product.allergensContained.length > 0;
  }

  get hasAllergensTraces(): boolean {
    return !!this.product.product.allergenTraces && this.product.product.allergenTraces.length > 0;
  }

  get hasNutritionInformation(): boolean {
    return !!this.product.product.nutritionInformationList && this.product.product.nutritionInformationList.length > 0;
  }

  get hasAllergenInformation(): boolean {
    return this.hasContainedAllergens || this.hasAllergensTraces;
  }

  get hasIntake(): boolean {
    return !!this.product.product.nutritionInformationList
      ?.find((nutritionInformation) => nutritionInformation.hasIntake);
  }
}
